import { motion } from "framer-motion";
import { Rocket } from "lucide-react";

export default function LaunchCTA({ onLaunch, onLaunchApp }) {
  return (
    <section data-testid="launch-cta-section" className="min-h-screen flex flex-col items-center justify-center relative px-6">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#030406]/70 to-[#030406]/80 pointer-events-none" />
      <motion.div
        className="text-center max-w-2xl relative z-10"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.4 }}
        transition={{ duration: 0.8 }}
      >
        <span className="overline mb-6 inline-block text-glow-cyan text-sm">// CLOSED BETA</span>
        <h2 className="font-grotesk text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tighter text-white leading-none mb-5 text-glow-cyan">
          Be early to the fastest prediction market layer on Base.
        </h2>
        <p className="font-grotesk text-base text-slate-300 max-w-md mx-auto mb-10">
          Closed beta is open for a limited cohort. Apply now and shape the protocol before public launch.
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <button
            data-testid="launch-engine-btn"
            onClick={onLaunch}
            className="hero-launch-btn cyan-glow inline-flex items-center gap-3"
          >
            <Rocket size={16} strokeWidth={1.5} /> Join Closed Beta
          </button>
          <button
            data-testid="launch-app-btn"
            onClick={onLaunchApp}
            className="hero-launch-btn cyan-glow inline-flex items-center gap-3"
          >
            <Rocket size={14} strokeWidth={1.5} /> Launch
          </button>
        </div>
        <p className="font-mono text-xs text-slate-500 mt-6 tracking-wider uppercase">
          Testnet on Base Chain · Q2 2026
        </p>
      </motion.div>
    </section>
  );
}
